import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/core/auth/_services/auth.service';

@Component({
	selector: 'kt-logout',
	templateUrl: './logout.component.html'
})
export class LogoutComponent implements OnInit {
	/**
	 * Component constructor
	 *
	 * @param authService: AuthService
	 */
	constructor(private authService: AuthService) {}

	public loader = false;

	// eslint-disable-next-line @typescript-eslint/no-empty-function
	ngOnInit() {}

	logout(): void {
		this.loader = true;
		this.authService.logout();
	}
}
